import { setExpandedItemsByKey } from '@client/hooks/use-expand-elements.hooks';
import { CSV_IMPORT_EXPAND_PREFIX } from './csv-import.constants';

/**
 * Accordion expand for import file sections (persisted per project). Opening
 * one file collapses all others; closing only affects the target file.
 */
export const setCsvImportFileExpanded = (
  allImportIds: readonly string[],
  importId: string,
  expanded: boolean,
): void => {
  if (expanded) {
    for (const id of allImportIds) {
      setExpandedItemsByKey(CSV_IMPORT_EXPAND_PREFIX, id, id === importId);
    }
    return;
  }
  setExpandedItemsByKey(CSV_IMPORT_EXPAND_PREFIX, importId, false);
};
